import * as yup from "yup";
import { CustomerSearchDataFragment } from "@bonliva-crm/graphql";

export interface OpportunityFormData {
  consultantId: string;
  customer: CustomerSearchDataFragment | null;
  costCenter: LabelValue | null;
  areaOfExpertise: LabelValue | null;
  estimatedResponseDate: Date | null;
  note: string;
  weeks: Array<Date>;
  type: "own" | "shared";
  user: LabelValue | null;
}

export const formCreateSchema = yup.object({
  customer: yup.object().required(),
  costCenter: yup.object().required(),
  areaOfExpertise: yup.object().nullable(true),
  note: yup.string(),
  estimatedResponseDate: yup.date().required().nullable(false),
  weeks: yup.array().min(1),
  type: yup.mixed().oneOf(["own", "shared"]).required(),
  user: yup
    .object()
    .nullable(true)
    .when("type", {
      is: "shared",
      then: (schema) => {
        return schema.required("User is required when type is shared");
      },
      otherwise: (schema) => {
        return schema.nullable(true);
      }
    })
});

export const formEditSchema = yup.object({
  customer: yup.object().required(),
  costCenter: yup.object().required(),
  areaOfExpertise: yup.object().nullable(true),
  note: yup.string(),
  estimatedResponseDate: yup.date().required().nullable(false)
});
